import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

/**
 * Step 1 of password recovery: request a reset code by email.
 *
 * Cognito resolves this for unknown emails too (preventUserExistenceErrors),
 * so the next page says "if an account exists" rather than confirming it.
 */
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
})
export class ForgotPasswordComponent implements OnInit {
  email = '';
  error: string | null = null;
  loading = false;

  constructor(
    private readonly auth: AuthService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.email = this.route.snapshot.queryParamMap.get('email') ?? '';
  }

  async onSubmit(): Promise<void> {
    const email = this.email.trim();
    if (!email) {
      this.error = 'Enter the email address for your account.';
      return;
    }

    this.error = null;
    this.loading = true;
    try {
      await this.auth.requestPasswordReset(email);
      await this.router.navigate(['/reset-password'], { queryParams: { email } });
    } catch (err: unknown) {
      this.error = err instanceof Error ? err.message : 'Could not send a reset code. Please try again.';
    } finally {
      this.loading = false;
    }
  }
}
